import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid,
  Tooltip, ResponsiveContainer, Legend, Area, AreaChart,
} from "recharts";

const fmtINR = (v) => {
  if (v >= 1_00_00_000) return `${(v / 1_00_00_000).toFixed(1)}Cr`;
  if (v >= 1_00_000) return `${(v / 1_00_000).toFixed(0)}L`;
  return v.toLocaleString("en-IN");
};

const TrendAnalysis = ({ trends }) => {
  if (!trends || trends.length === 0) return <p className="text-center text-muted-foreground py-8">No trend data available</p>;

  return (
    <div className="space-y-4" data-testid="trend-analysis">
      {/* Inventory vs Procurement Spend */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Card className="card-industrial">
          <CardHeader className="pb-2">
            <CardTitle className="text-sm">Inventory Value vs Procurement Spend</CardTitle>
          </CardHeader>
          <CardContent>
            <ResponsiveContainer width="100%" height={280}>
              <AreaChart data={trends}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                <XAxis dataKey="period" tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 11 }} tickFormatter={fmtINR} />
                <Tooltip formatter={(v) => `INR ${v.toLocaleString("en-IN")}`} />
                <Legend iconSize={10} wrapperStyle={{ fontSize: 11 }} />
                <Area type="monotone" dataKey="inventory_value" name="Inventory" stroke="#16a34a" fill="#16a34a" fillOpacity={0.15} strokeWidth={2} />
                <Area type="monotone" dataKey="procurement_spend" name="Spend" stroke="#7c3aed" fill="#7c3aed" fillOpacity={0.15} strokeWidth={2} />
              </AreaChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>

        <Card className="card-industrial">
          <CardHeader className="pb-2">
            <CardTitle className="text-sm">Cost Savings Trend</CardTitle>
          </CardHeader>
          <CardContent>
            <ResponsiveContainer width="100%" height={280}>
              <BarChart data={trends}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                <XAxis dataKey="period" tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 11 }} tickFormatter={fmtINR} />
                <Tooltip formatter={(v) => `INR ${v.toLocaleString("en-IN")}`} />
                <Bar dataKey="savings" name="Savings" fill="#059669" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      </div>

      {/* Performance Metrics Trend */}
      <Card className="card-industrial">
        <CardHeader className="pb-2">
          <CardTitle className="text-sm">Cross-Module Performance Trends (%)</CardTitle>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={trends}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis dataKey="period" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} domain={[0, 100]} tickFormatter={(v) => `${v}%`} />
              <Tooltip formatter={(v) => `${v}%`} />
              <Legend iconSize={10} wrapperStyle={{ fontSize: 11 }} />
              <Line type="monotone" dataKey="otif_inbound" name="Inbound OTIF" stroke="#16a34a" strokeWidth={2} dot={{ r: 3 }} />
              <Line type="monotone" dataKey="otif_outbound" name="Outbound OTIF" stroke="#0891b2" strokeWidth={2} dot={{ r: 3 }} />
              <Line type="monotone" dataKey="po_compliance" name="PO Compliance" stroke="#7c3aed" strokeWidth={2} dot={{ r: 3 }} />
              <Line type="monotone" dataKey="vendor_otd" name="Vendor OTD" stroke="#d97706" strokeWidth={2} dot={{ r: 3 }} />
              <Line type="monotone" dataKey="fill_rate" name="Fill Rate" stroke="#dc2626" strokeWidth={2} dot={{ r: 3 }} />
            </LineChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    </div>
  );
};

export default TrendAnalysis;
